import getConfig from 'next/config';
import { useRouter } from 'next/router';
import React, { memo, useMemo } from 'react';

import { GlobalSearch } from '@sravni/react-search';

import { useCurrentLocation } from '@src/reducers/locations';
import { useSelectHeaderSettings } from '@src/reducers/siteSettings';
import { useSelectUser } from '@src/reducers/user';

import { getHeader } from '../lib';

interface Props {
  mode: 'landing' | 'default';

  variant?: 'mobile' | 'desktop';
}

export const Header = memo(({ mode, variant }: Props) => {
  const { asPath } = useRouter();

  const headerSettings = useSelectHeaderSettings();
  const currentLocation = useCurrentLocation();
  const user = useSelectUser();

  const InnerHeader = useMemo(() => getHeader(variant), [variant]);

  return (
    <InnerHeader
      currentRegion={currentLocation}
      settings={headerSettings}
      user={user}
      mode={mode}
      enableTheme
      search={<GlobalSearch searchServiceHost={getConfig().publicRuntimeConfig.publicUrl} asPath={asPath} />}
    />
  );
});

Header.displayName = 'Header';
